import { AUTH_STORAGE_KEY } from '@src/corelib/auth/storages';

function getLocaleForAuthUser() {
  let language = 'en-US';
  const value = localStorage.getItem(AUTH_STORAGE_KEY);
  const authData = JSON.parse(value);
  if (authData) {
    const userLanguage = authData.user.language;
    if (userLanguage) {
      language = userLanguage;
    }
  }
  return language;
};

const locale = getLocaleForAuthUser();
export default locale;
